import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { TimesheetWorkedTimeBlockFragment } from 'generated/resources/graphql'
import groupBy from 'lodash/groupBy'

import i18n from 'modules/core/lib/i18n'

import BlocksBreakdown from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Worked/RegularAndOvertime/Overtime/BlocksBreakdown'
import useToggleOpen from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Worked/RegularAndOvertime/Overtime/hooks/useToggleOpen'
import { useTimeSettingsCategory } from 'modules/attendance/lib/timeSettingsCategoryContext'
import { AggregateWorkedTimeBlocksFilter } from 'modules/attendance/store/models/AggregateWorkedTimeFilter'

interface Props {
  workedTimeBlocks?: TimesheetWorkedTimeBlockFragment[]
}

const TimeCategories = ({ workedTimeBlocks }: Props) => {
  const { timeSettingsCategories } = useTimeSettingsCategory()
  const { open, toggleOpen } = useToggleOpen()

  if (!workedTimeBlocks?.length) return null
  if (!timeSettingsCategories.hasTimeSettingsCategories) return null

  const filteredWorkedTimeBlocks = new AggregateWorkedTimeBlocksFilter(workedTimeBlocks)

  if (!filteredWorkedTimeBlocks.withApprovedTimeSettingsCategoryMinutes) return null

  const timeBlocksByCategory =
    workedTimeBlocks && groupBy(workedTimeBlocks, (block) => block.timeRangeCategoryId)

  return (
    <Box gap="s8">
      <Box flexDirection="row" gap="s8" alignItems="center">
        <Icon.Small icon="dark-mode" color="grey600" />
        <Text size="100" weight="bold" color="grey800">
          {i18n.t('clock_in.sidepanel.time_categories').toUpperCase()}
        </Text>
      </Box>
      <Box gap="s4">
        {Object.keys(timeBlocksByCategory).map((blockCategory) => (
          <BlocksBreakdown
            key={blockCategory}
            category={timeSettingsCategories.customTimeRangeCategories.find(
              (category) => category.id === +blockCategory
            )}
            open={open}
            toggleOpen={toggleOpen}
            workedTimeBlocks={timeBlocksByCategory[blockCategory] || []}
          />
        ))}
      </Box>
    </Box>
  )
}

export default TimeCategories
